import { Badge } from "@/core/components/ui/badge";
import { NoTranslate } from "@/core/components/ui/no-translate";
import { cn } from "@/core/utils/func/cn";
import type { NotificationStatus } from "@/features/shared/api/enums";

/**
 * Couleurs de statut par tokens du design system (règle projet : jamais de
 * classes palette brutes) — surfaces `-muted` + teinte du token.
 * Mapping : QUEUED → info, SENT → info, DELIVERED → success, FAILED → destructive.
 */
const STATUS_STYLES: Record<NotificationStatus, string> = {
  QUEUED: "border-info/40 bg-info-muted text-info",
  SENT: "border-info/40 bg-info-muted text-info",
  DELIVERED: "border-success/40 bg-success-muted text-success",
  FAILED: "border-destructive/40 bg-destructive/10 text-destructive",
};

/**
 * Badge de statut d'une notification (énumération MAJUSCULES de l'annexe A,
 * affichée littéralement en `NoTranslate`).
 */
export function NotificationStatusBadge({
  status,
}: {
  status: NotificationStatus;
}) {
  return (
    <NoTranslate as="span">
      <Badge variant="outline" className={cn(STATUS_STYLES[status])}>
        {status}
      </Badge>
    </NoTranslate>
  );
}
